import React from 'react';
//import PropTypes from 'prop-types';

import { debounce } from 'lodash';

import * as convert from '_core/utils/convert';
import * as storage from '_core/utils/storage';
import * as math from '_core/utils/math';
import * as api from '_core/utils/api';
import AddressInput from '_core/components/AddressInput';


const WAREHOUSE_STORAGE_KEY = 'shop-warehouse';


const storeOptions = debounce(async (options, setOptions, isConfirmed, locality, warehouse) => {
  const localityId = isConfirmed && locality.id || null;
  const warehouseId = isConfirmed && warehouse.id || null;
  
  if (options.locality === localityId && options.warehouse === warehouseId)
    return;
  
  setOptions({ id: options.id, locality: localityId, warehouse: warehouseId });
  
  if (isConfirmed)
    AddressInput.store(locality);
  
  storage.set(WAREHOUSE_STORAGE_KEY, warehouseId);
  
  try {
    const token = await api.getClientTokenGenerate(options.id);
    
    api.putDeliveryOptions(token, { locality: localityId, warehouse: warehouseId });
  } catch (e) {
    console.error(e);
  }
}, 1000);


export default (cart, langCode, visitorInfo) => {
  const [options, setOptions] = React.useState();
  const [isRequest, setIsRequest] = React.useState(false);
  const [isConfirmed, setIsConfirmed] = React.useState(false);
  const [locality, setLocality] = React.useState();
  const [warehouseList, setWarehouseList] = React.useState();
  const [warehouse, setWarehouse] = React.useState();
  
  const visitorId = visitorInfo.info?.id;
  
  
  // options & locality
  
  React.useEffect(() => {
    if (!visitorId)
      return;
    
    const loadData = async () => {
      // options
      
      let options;
      
      try {
        const token = await api.getClientTokenGenerate(visitorId);
        
        options = await api.getDeliveryOptions(token);
      } catch (e) {
        console.error(e);
        
        options = { id: visitorId, locality: null, warehouse: null };
      }
      
      setOptions(options);
      
      
      // locality
      
      let locality;
      
      try {
        const localityId = !AddressInput.load() && (options.locality || visitorInfo.info.locality);
        
        if (localityId) {
          locality = (await api.getAddressLocality(langCode, localityId))[localityId];
          
          setIsConfirmed(true);
        } else {
          locality = await AddressInput.locate(langCode || 'en')
        }
      } catch (e) {
        console.error(e);
        
        locality = null;
      }
      
      setLocality(locality);
    };
    
    loadData();
  }, [langCode, visitorId]);
  
  
  // warehouse list
  
  React.useEffect(() => {
    const loadData = async () => {
      let warehouseList;
      
      try {
        warehouseList = await api.getDeliveryWarehouse();
        
        warehouseList = warehouseList
          .filter((item) => visitorInfo.inGroup(item.visitor_group))
          .map((item) => ({
            ...item,
            
            locality: item.locality && api.getAddressLocality(langCode, item.locality).then((map) => map[item.locality])
          }));
        
        await Promise.all(warehouseList.map(async (item) => item.locality && (item.locality = await item.locality)));
        
        warehouseList.forEach((item) => item.distance = locality?.location && item.location ? math.sqr(item.location[0] - locality.location[0]) + math.sqr(item.location[1] - locality.location[1]) : Infinity);
        
        warehouseList = warehouseList.filter((item) => item.is_external_delivery
          || item.is_internal_pickup && item.distance < 9
          || item.is_internal_delivery_region && item.distance < 9
          || item.is_internal_delivery_country && item.locality?.country?.[0] === locality?.country?.[0]
          || item.is_internal_delivery_world);
        
        warehouseList.sort((item1, item2) => math.compare(item2.is_external_delivery, item1.is_external_delivery)
          || math.compare(item2.is_internal_delivery_region, item1.is_internal_delivery_region)
          || math.compare(item2.is_internal_delivery_country, item1.is_internal_delivery_country)
          || math.compare(item2.is_internal_delivery_world, item1.is_internal_delivery_world)
          || math.compare(item1.distance, item2.distance)
          || math.compare(item1.id, item2.id));
      } catch (e) {
        console.error(e);
        
        warehouseList = [];
      }
      
      setWarehouseList(warehouseList);
    };
    
    loadData();
  }, [langCode, locality]);
  
  
  // warehouse
  
  React.useEffect(() => {
    if (!warehouseList || !options)
      return;
    
    const warehouseId = options?.warehouse || convert.toInt(storage.get(WAREHOUSE_STORAGE_KEY));
    
    const warehouse = warehouseId && warehouseList.find((item) => item.id == warehouseId) || warehouseList[0];
    
    setWarehouse(warehouse || warehouseList[0] || null);
  }, [warehouseList, options]);
  
  
  // save options
  
  React.useEffect(() => {
    if (!options || typeof locality === 'undefined' || typeof warehouse === 'undefined')
      return;
    
    storeOptions(options, setOptions, isConfirmed, locality, warehouse);
  }, [options, isConfirmed, locality, warehouse]);
  
  
  return {
    options,
    isRequest,
    setIsRequest,
    isConfirmed,
    setIsConfirmed,
    locality,
    setLocality,
    getLocalityValue: (reverse = false) => AddressInput.buildValue('delivery', 'city', locality, reverse),
    warehouseList,
    warehouse,
    setWarehouse
  };
};
